<template>
  <div class="languages">
    <div
      v-for="(lang, index) in availableLangs"
      :class="{ active: currentLocale === lang.locale }"
      class="languages__lang"
      :key="index"
      @click="switchLocale(lang.locale)"
    >
      {{ $t(lang.translation) }}
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import { Locale } from '@/enumerations/Locale';
import i18n, { languages } from '@/plugins/i18n';
import { setLocaleToLS } from '@/modules/LocaleStorage';

@Component
export default class LanguageToggle extends Vue {
  private langs = [
    {
      translation: 'russian',
      locale: Locale.Ru,
    },
    {
      translation: 'ukrainian',
      locale: Locale.Uk,
    },
    {
      translation: 'english',
      locale: Locale.En,
    },
  ];

  private get availableLangs() {
    return this.langs.filter(lang => languages.includes(lang.locale));
  }

  private get currentLocale() {
    return i18n.locale;
  }

  private switchLocale(locale: Locale) {
    i18n.locale = locale;
    setLocaleToLS(locale);
  }
}
</script>

<style scoped lang="scss">
@import '../assets/styles/variables';
.languages {
  display: flex;
  margin-right: 30px;

  &__lang {
    display: flex;
    align-items: center;
    cursor: pointer;

    &:not(:last-child) {
      margin-right: 15px;
    }

    &.active {
      color: $--color-white-48;
    }
  }
}
</style>
